import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import LoadingSpinner from '../atoms/loading';
import Checkbox from '../atoms/checkbox';
import I10n from '../features/i10n';
import Scrollbars from 'react-custom-scrollbars';
import ProductLink from './product_link';
import ProductInformationCache from '../persistence/description-cache';

const Container = styled.div`
  width: 100%;
  height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 800px) {
    display: block;
    height: auto;
  }
`;

const SoftwareContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
  border: 1px solid #E7E6E6;
`;

const SoftwareImage = styled.img`
  height: 50px;
  width: 50px;
  min-height: 50px;
  min-width: 50px;
`;

const SoftwareTitle = styled.a`
  font-size: 12px;
  line-height: 20px;
  display: inline-block;
`;

const SoftwareDescription = styled.span`
  font-size: 12px;
  line-height: 20px;
`;

const SoftwareCheckboxWrapper = styled.div`
  margin-right: 5px;
`;

const EmptySoftwareText = styled.span`
`;

const SoftwareInformationContainer = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 50px;
  padding: 0 10px;
`;

const ScrollbarWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  width: 100%;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileWrapper = styled.div`
  display: none;
  flex: 1 1 0px;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const SoftwareWrapper = styled.div`
  flex: 1 1 0px;
  padding-right: 10px;
`;

const LoadingPositionner = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const LoadingWrapper = styled.div`
  height: 30px;
  width: 30px;
`;

class SoftwareAccesorySelector extends React.Component {

  static propTypes = {
    isLoadingSoftwares: PropTypes.bool,
    isLoadingConfiguration: PropTypes.bool,
    selectedSoftwareList: PropTypes.array,
    softwareList: PropTypes.array,
    onSoftwareUpdate: PropTypes.func
  }

  handleChange(newStatus, productId) {
    let newSoftwareList = [...this.props.selectedSoftwareList];
    if (newStatus === true) {
      newSoftwareList.push(productId);
    } else {
      // Remove the software unselected
      newSoftwareList = newSoftwareList.filter(software => software !== productId);
    }

    // Clear no longer existing software
    newSoftwareList.filter(software => this.props.softwareList.includes(software));

    this.props.onSoftwareUpdate(newSoftwareList);
  }

  renderSoftware = (software, key) => {
    const selected = this.props.selectedSoftwareList.includes(software);
    return (<SoftwareContainer key={key}>
      <SoftwareImage src={`https://gw-api.schneider-electric.com/sc/products/image/${software}?width=50&height=50`}>
      </SoftwareImage>
      <SoftwareInformationContainer>
        <SoftwareTitle>
          <ProductLink reference={software}></ProductLink>
        </SoftwareTitle>
        <SoftwareDescription>{ProductInformationCache.getDescription(software)}</SoftwareDescription>
      </SoftwareInformationContainer>
      <SoftwareCheckboxWrapper>
        <Checkbox onChange={(event => { event.preventDefault(); this.handleChange(!selected, software) })} checked={this.props.selectedSoftwareList.includes(software)} disabled={this.props.isLoadingConfiguration}></Checkbox>
      </SoftwareCheckboxWrapper>
    </SoftwareContainer>);
  }

  renderSoftwares = () => {
    return <SoftwareWrapper>
      {this.props.softwareList?.length > 0 ?
        this.props.softwareList.map((software, key) => this.renderSoftware(software.id, key)) :
        <EmptySoftwareText>{I10n.get('screen.config_editor.software_empty')}</EmptySoftwareText>
      }
    </SoftwareWrapper>;
  }

  render = () => {
    return (
      <Container>
        {this.props.isLoadingSoftwares ?
          <LoadingPositionner>
            <LoadingWrapper>
              <LoadingSpinner></LoadingSpinner>
            </LoadingWrapper>
          </LoadingPositionner>
          :
          <>
            <ScrollbarWrapper>
              <Scrollbars>
                {this.renderSoftwares()}
              </Scrollbars>
            </ScrollbarWrapper>
            <MobileWrapper>
              {this.renderSoftwares()}
            </MobileWrapper>
          </>
        }
      </Container>
    );

  }

}

export default SoftwareAccesorySelector;
